<template>
      <v-container fluid class="fifth pb-12">

        <v-container>
            <v-row>
                <v-col>
                    <h1 class="primary--text display-2 mb-4">Projects</h1>
                </v-col>
            </v-row>
            <v-row class="d-flex align-center justify-space-between">
                <v-col v-for="proj in projects" :key="proj.name" sm="4" cols="12">
                    <v-card class="primary pb-4" flat style="border: 4px solid black">
                        <v-img
                        :src="proj.img"
                        max-height="200px"
                        aspect-ratio="1.0"
                        
                        />                        <!--style="border-radius: 8px;"-->

                        <v-card-title class="fifth--text display-1 font-weight-bold">{{ proj.title }}</v-card-title>
                        <v-card-subtitle class="pb-2 fifth--text title font-weight-regular">{{ proj.subtitle }}</v-card-subtitle>
                        
                        <div class="ml-2 mt-2 ">
                        <span 
                        v-for="lang in proj.language"
                        :key="lang.name"
                        class="ml-1 pr-4 pl-4 pt-1 pb-1 font-weight-bold subtitle-1"
                        :class="lang.color"
                        style="border-radius:16px;">{{lang.lg}}</span>
                        </div>
                        <v-card-text class="pt-2 fifth--text subtitle-1 font-weight-regular">{{ proj.text }}</v-card-text>

                        <div class="d-flex justify-space-around">
                            <v-btn
                            :href="proj.web1.url"
                            outlined
                            class="font-weight-regular fifth--text"
                            depressed
                            target="_blank"
                            width="45%"
                            >
                                {{ proj.web1.text }}
                            </v-btn>

                            <v-btn 
                            :href="proj.web2.url"
                            outlined
                            class="font-weight-regular fifth--text"
                            depressed
                            target="_blank"
                            width="45%">
                                {{ proj.web2.text }}
                            </v-btn>
                        </div>
                    </v-card>
                </v-col>                
            </v-row>
        </v-container>
      </v-container>
</template>

<script>        //https://github.com/rogov-dvp/Images/blob/master/personal-web/MMphoto.jpg?raw=true
export default {
data: ()=> {
    return {
            projects: [{
                title: 'Malzar\'s Maze',
                subtitle: 'Game',
                text: 'Unique maze game where player must collect treasure and escape a minotaur with realistic limited visability. Play: Java 7 or up.',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/MMcover.png?raw=true',
                web1: {text: 'Youtube', url: 'https://www.youtube.com/watch?v=Q3XE2ARTzzw'},
                web2: {text: 'Play', url: 'https://github.com/rogov-dvp/Java-Projects/blob/master/PLAYME/Malzars-Maze.jar?raw=true'}, 
                language: [{lg:'Java', color: 'third'}],    
           },{
                title: 'Area 51 Gift Store',
                subtitle: 'E-commerce web app',
                text: 'Developed a fun online-store. Recognized as a top website by the professor from a class of 200 students.',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/Area51Cut.png?raw=true',
                web1: {text: 'GitHub', url:'https://github.com/rogov-dvp/AREA-51-Website'},
                web2: {text: 'Website', url:'https://cosc304.ok.ubc.ca/52162740/php/index.php'},
                language: [{lg:'PHP', color:'purple lighten-3'}, {lg:'SQL', color: 'light-blue lighten-3'},
                {lg:'HTML', color: 'red lighten-3'}, {lg:'CSS', color: 'blue lighten-3'}],    
            },{
                title: 'Apurva Bot',
                subtitle: 'Chatbot',
                text: 'Developed a JavaScript-based chatbot that discuss Software Development Life Cycles. Project manager in a team of 4.',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/robotCut.png?raw=true',
                web1: {text: 'GitHub', url: 'https://github.com/rogov-dvp/ChatBot-COSC-310'},
                web2: {text: 'Website', url: 'https://chatbot-prof.firebaseapp.com/'},
                language: [{lg:'JavaScript', color:'secondary'}, {lg:'Vue.js', color: 'green lighten-3'},
                {lg:'HTML', color: 'red lighten-3'}, {lg:'CSS', color: 'blue lighten-3'}],   
            }]
    }
}
}
</script>

<style>

</style>